module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQDesc: `Identify your correct shade in every foundation and concealer product. Head to a [Sephora store|${vars[0]}] and ask for a Color IQ skin tone scan.`
    };
    return resources[label];
};
